import React from 'react';

export const MessageLeavePage = (): React.JSX.Element => (
  <>
    There are unsaved changes on this page.
    <br />
    Do you want to leave without saving them?
  </>
);
